import { Fragment, useMemo } from 'react';
import { NavMarker } from 'react-rhumb';
import { useLocation, useParams } from 'react-router-dom';
import { useQuery } from 'data-fetching-client';
import ModuleDetailsResponse from 'marketplace-ui-assets-core/details/records/ModuleDetailsResponse';
import HSPageViewTracker from 'marketplace-ui-common/tracking/components/HSPageViewTracker';
import * as RequestState from 'marketplace-ui-common/requestStates/RequestState';
import { getDataFetchingClientRequestState } from 'marketplace-ui-common/dataFetchingClient/utils/getDataFetchingClientRequestState';
import getDataFetchingClientStatus from 'marketplace-ui-common/dataFetchingClient/utils/getDataFetchingClientErrorStatus';
import DocumentHead from 'ecosystem-marketplace-core/components/portals/DocumentHead';
import MetaRobots from 'marketplace-ui-common/components/elements/MetaRobots';
import PrerenderReady from 'ecosystem-marketplace-core/components/prerender/PrerenderReady';
import PrerenderStatusCode from 'marketplace-ui-common/components/prerender/PrerenderStatusCode';
import { GET_MODULE_DETAILS } from '../queries/moduleDetailsQuery';
import { PublicOnly } from '../../selectors/app';
import { getRootUrl } from '../../utils/urls';
import ModuleDetailsPage from '../components/ModuleDetailsPage';
import NotFoundError from '../../components/error/NotFoundError';
import NoAccessError from '../../components/error/NoAccessError';
import GenericError from '../../components/error/GenericError';
import StorefrontUsageTrackerProvider from '../../context/StorefrontUsageTrackerProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ModuleDetailsError = ({
  children
}) => /*#__PURE__*/_jsxs(Fragment, {
  children: [/*#__PURE__*/_jsx(PublicOnly, {
    children: /*#__PURE__*/_jsxs(DocumentHead, {
      children: [/*#__PURE__*/_jsx(MetaRobots, {
        directive: ['nofollow', 'noindex']
      }), /*#__PURE__*/_jsx(PrerenderReady, {}), /*#__PURE__*/_jsx(PrerenderStatusCode, {
        statusCode: 404
      })]
    })
  }), children]
});
export default function ModuleDetailsContainer() {
  const {
    pathname
  } = useLocation();
  const {
    slug
  } = useParams();
  const {
    loading,
    error,
    data,
    previousData
  } = useQuery(GET_MODULE_DETAILS, {
    variables: {
      slug
    }
  });
  const moduleDetails = useMemo(() => {
    const moduleDetailsData = data || previousData;
    return new ModuleDetailsResponse(moduleDetailsData ? moduleDetailsData.details : undefined);
  }, [data, previousData]);
  const requestState = getDataFetchingClientRequestState(error, loading);
  if (error) {
    switch (getDataFetchingClientStatus(error)) {
      case 403:
        {
          return /*#__PURE__*/_jsx(ModuleDetailsError, {
            children: /*#__PURE__*/_jsx(NavMarker, {
              name: "MODULE_DETAILS_403_LOAD",
              children: /*#__PURE__*/_jsx(NoAccessError, {})
            })
          });
        }
      case 404:
        {
          return /*#__PURE__*/_jsx(ModuleDetailsError, {
            children: /*#__PURE__*/_jsx(NavMarker, {
              name: "MODULE_DETAILS_404_LOAD",
              children: /*#__PURE__*/_jsx(NotFoundError, {})
            })
          });
        }
      default:
        {
          return /*#__PURE__*/_jsx(ModuleDetailsError, {
            children: /*#__PURE__*/_jsx(NavMarker, {
              name: "MODULE_DETAILS_ERROR_LOAD",
              children: /*#__PURE__*/_jsx(GenericError, {})
            })
          });
        }
    }
  }
  return /*#__PURE__*/_jsxs(StorefrontUsageTrackerProvider, {
    children: [requestState === RequestState.SUCCEEDED ? /*#__PURE__*/_jsx(ModuleDetailsPage, {
      moduleDetails: moduleDetails
    }, `module-details-${slug}`) : null, /*#__PURE__*/_jsx(HSPageViewTracker, {
      pathname: `${getRootUrl()}${pathname}`
    })]
  });
}